const items = ["Mayfair", "Knightsbridge", "Belgravia", "Kensington", "Chelsea", "Marylebone", "Notting Hill", "Soho"];

export default function Marquee() {
  const row = (id) => (
    <div key={id} className="flex shrink-0 items-center" aria-hidden={id === "b"}>
      {items.map((city, i) => (
        <span key={city} className="flex items-center">
          <span className={`font-serif text-5xl md:text-7xl tracking-tight whitespace-nowrap ${i % 2 ? "italic font-light text-black/70" : ""}`}>
            {city}
          </span>
          <span className="text-[#D4512D] text-3xl mx-10" aria-hidden="true">
            ◦
          </span>
        </span>
      ))}
    </div>
  );

  return (
    <section data-testid="marquee-strip" className="marquee-hover border-b border-black/15 py-10 md:py-14 overflow-hidden bg-[#EBE9E1]">
      <div className="flex animate-marquee will-change-transform">
        {row("a")}
        {row("b")}
      </div>
    </section>
  );
}
